import apiFetch from '../apiFetch'

export default function (idLinea, token) {
  return apiFetch({endPoint: `LineaGenetica/deleteLineaGenetica`, method: 'POST', body: {idLinea}, token: token})
}